<template>
  <div class="expired-baskets h-100 w-100">
    <b-overlay
      :show="loading"
      :rounded="false"
      :spinner-small="true"
      bg-color="white"
    >
      <div v-if="!loading">
        <expired-basket-item
          v-for="(item, index) in expired_baskets"
          :key="index"
          :value="item"
        ></expired-basket-item>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ExpiredBasketItem from "@/components/ExpiredBasketItem";

export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {
    ExpiredBasketItem,
  },
  mounted() {
    this.loading = true;

    this.$store.dispatch("basket/load_expired_baskets").then(() => {
      this.loading = false;
    });
  },
  computed: {
    ...mapState("basket", ["expired_baskets"]),
  },
};
</script>